import React, { useCallback, useState } from 'react';
import { block as parentBlock } from './helper';

const block = `${parentBlock}__search-form`;

/**
 * ProviderSelectResults component handles the provider search or filter input UI.
 *
 * @param {object} props - The component props.
 * @param {boolean} [props.filter=false] - Whether this input filters existing results or performs a new search.
 * @param {object} props.inputRef - Ref for the search input element. wrong not an object
 * @param {Function} [props.onClickClear] - Handler for clearing the search input.
 * @param {Function} [props.onChange] - Handler for input value changes.
 */
const ProviderSelectResults = ({
  filter = false,
  inputRef,
  onClickClear = () => {},
  onChange = () => {},
}) => {
  const [showClear, setShowClear] = useState(false);

  const handleChange = useCallback(
    (e) => {
      const { value } = e.target;
      setShowClear(value.length > 0);
      onChange(e, filter);
    },
    [onChange, filter],
  );

  const handleClear = useCallback(
    (e) => {
      setShowClear(false);
      onClickClear(e);
    },
    [onClickClear],
  );

  const placeholder = filter
    ? 'Type provider name to filter'
    : 'Type provider name to search';

  return (
    <div className={block}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <input
          type="text"
          ref={inputRef}
          placeholder={placeholder}
          onChange={handleChange}
          className={`${block}__input-text ${block}__input-text__search`}
        />
      </form>
      <div className={`${block}__search-icon`}>
        {!showClear ? (
          <button
            type="button"
            className={`${parentBlock}__button ${block}__button`}
            onClick={() => inputRef?.current?.focus()}
          >
            <span className="icon icon-search" />
          </button>
        ) : (
          <button
            type="button"
            className={`${parentBlock}__button ${block}__button`}
            onClick={handleClear}
          >
            <span className="icon icon-close" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ProviderSelectResults;

